module.exports = __webpack_public_path__ + "img/marisa kirisame lunar war enchanter.ce49625d.png";